<script>
  import { slide } from 'svelte/transition';
  import { onMount } from 'svelte';
  import AuthorAvatar from '../../Common/AuthorAvatar.svelte';
  import Image from './Attachments/Image.svelte';
  import { External } from '../../external';
  import QuillEditor from '../../Common/QuillEditor/QuillEditor.svelte';
  import EmojiPicker from './EmojiPicker/EmojiPicker.svelte';

  export let service,
    author,
    input = '',
    attachments = null,
    focused = false,
    onSend = () => {},
    allowImages = false;

  let quillEditor;

  const fileInput = {
    accept: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.wbmp', '.ico', '.svg', '.webp', '.avif'].join(', '),
    element: null,
    selectedFile: null,
    selectedFileSrc: null,
    onChanged: () => {
      fileInput.selectedFile = fileInput.element.files[0];
      fileInput.readFile(fileInput.selectedFile);
    },
    readFile: (file) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        fileInput.selectedFileSrc = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    click: () => {
      fileInput.element.click();
    },
    clear: () => {
      fileInput.element.value = '';
      fileInput.selectedFile = null;
      fileInput.selectedFileSrc = null;
    },
    remove: () => {
      fileInput.clear();
      if (attachments?.image) {
        attachments.image = null;
      }
    }
  };

  const onSendClick = async () => {
    const isImageExists = () => {
      if (fileInput.selectedFile) {
        return true;
      }
      return !!attachments?.image;
    };

    if (!isImageExists()) {
      if (!input || input.length === 0) {
        return;
      }
    }

    if (fileInput.selectedFile) {
      const image = await service.uploadImageAndReturnDetails(fileInput.selectedFile);
      if (attachments) {
        attachments = { image: image };
      }
      onSend(input, { image: image });
    } else {
      onSend(input, attachments);
    }
    input = '';
    if (quillEditor) {
      quillEditor.clear();
    }
    fileInput.clear();
  };

  const onQuillChange = (change) => {
    input = change.html;
  };
  const onPasteFromClipboard = (e) => {
    const { files } = e.clipboardData;
    const file = files[0];
    if (file?.type.includes('image')) {
      fileInput.selectedFile = file;
      fileInput.readFile(file);
    }
  };

  export const focus = () => {
    focused = true;
    setTimeout(() => {
      if (quillEditor) {
        quillEditor.focus();
      }
    }, 0);
  };

  const onNewEmoji = (emoji) => {
    quillEditor.insertText(emoji.unicode, { atCursor: true });
    quillEditor.focus();
  };

  onMount(() => {
    if (attachments?.image) {
      fileInput.selectedFileSrc =
        External.getThumbnailsFromBase(attachments.image.base + '/', '640x480') + attachments.image.name + '?format=webp';
    }
  });
</script>

<div class="circle-post-reply-wrapper col20 f-left mt-15">
  <div out:slide class="col20 f-left circle-post-reply flex">
    <AuthorAvatar {author} />
    <div class="circle-post-comment-input col20 f-left">
      <QuillEditor bind:this={quillEditor} initial={input} {focused} onChange={onQuillChange} {onPasteFromClipboard} />
      <div class="comment-input-footer flex align-center">
        <div class="comment-input-reactions flex align-center f-left mr-5">
          <EmojiPicker {onNewEmoji} />
          <div class:none={!allowImages} on:click={fileInput.click} class="circle-round-btn circle-effect f-left">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
              <path
                d="M480-260q75 0 127.5-52.5T660-440q0-75-52.5-127.5T480-620q-75 0-127.5 52.5T300-440q0 75 52.5 127.5T480-260Zm0-80q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29ZM160-120q-33 0-56.5-23.5T80-200v-480q0-33 23.5-56.5T160-760h126l74-80h240l74 80h126q33 0 56.5 23.5T880-680v480q0 33-23.5 56.5T800-120H160Zm0-80h640v-480H638l-73-80H395l-73 80H160v480Zm320-240Z" />
            </svg>
          </div>
          <div class:none={true} class="circle-round-btn circle-effect f-left">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
              <path
                d="M340-400h40q17 0 28.5-11.5T420-440v-40h-40v40h-40v-80h80q0-17-11.5-28.5T380-560h-40q-17 0-28.5 11.5T300-520v80q0 17 11.5 28.5T340-400Zm120 0h40v-160h-40v160Zm80 0h40v-60h60v-40h-60v-20h80v-40H540v160ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
            </svg>
          </div>
          <div class:none={true} class="circle-round-btn circle-effect f-left">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
              <path
                d="M480-40q-149 0-254.5-42.5T120-200q0-32 20-57.5t56-45.5l65 58q-24 8-42.5 20.5T200-200q0 26 81 53t199 27q118 0 199-27t81-53q0-12-18.5-24.5T699-245l65-58q36 20 56 45.5t20 57.5q0 75-105.5 117.5T480-40Zm0-160q-22 0-42.5-7.5T400-230L148-453q-13-11-20.5-27t-7.5-33v-80q0-17 6.5-33t19.5-27l252-235q17-16 38-24t44-8q23 0 44 8t38 24l252 235q13 11 19.5 27t6.5 33v80q0 17-7.5 33T812-453L560-230q-17 15-37.5 22.5T480-200Zm-4-188q14 0 26.5-4.5T526-407l222-197-240-226q-7-5-14-7.5t-15-2.5q-8 0-15 2.5t-12 7.5L208-600l218 193q11 10 23.5 14.5T476-388ZM360-550q21 0 35.5-14.5T410-600q0-21-14.5-35.5T360-650q-21 0-35.5 14.5T310-600q0 21 14.5 35.5T360-550Zm50 54q43 21 90.5 13.5T584-522q34-29 44.5-73T618-678L410-496Zm70-174q21 0 35.5-14.5T530-720q0-21-14.5-35.5T480-770q-21 0-35.5 14.5T430-720q0 21 14.5 35.5T480-670Zm-2 56Z" />
            </svg>
          </div>
        </div>
        <a on:click={onSendClick} class="comment-send circle-effect f-left">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
            <path d="M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z" />
          </svg>
        </a>
      </div>
    </div>
  </div>
  <input
    type="file"
    accept={fileInput.accept}
    class="none"
    bind:this={fileInput.element}
    on:change={fileInput.onChanged} />
  {#if fileInput.selectedFileSrc}
    <Image imageSrc={fileInput.selectedFileSrc} showDelete={true} onDelete={fileInput.remove} />
  {/if}
</div>
